module.exports = __webpack_public_path__ + "static/media/Altair FEKO.1ffcd528.png";